import { Modal, Row, Col, DropdownButton, Dropdown, Button } from "react-bootstrap";
import { NFCeDto } from "../../NFCe.Dto";

interface Props {
  show: boolean;
  nfce: NFCeDto | undefined;
  onReturn: () => void;
  onDelete: (value: NFCeDto) => void;
  onPrint: (value: NFCeDto) => void;
  onDownloadXml: (value: NFCeDto) => void;
  onFetchStatus: (value: NFCeDto) => void;
  onDownloadDanfe: (value: NFCeDto) => void;
  onShareDanfe: (value: NFCeDto) => void;
}

const NFCeModalPropriedadesView = (props: Props) => {
  const finalizada = props.nfce?.autorizacao?.codigoStatusResposta === 100;

  const onVisualizarHandler = () => {
    if (props.nfce) {
      window.open(`/fiscal/nfce/consulta/${props.nfce.id}/visualizar`, "_blank");
    }
  };

  const onReturnHandler = () => {
    if (props.nfce) {
      props.onReturn();
    }
  };

  const onDeleteHandler = () => {
    if (props.nfce) {
      props.onReturn();
      props.onDelete(props.nfce);
    }
  };

  const onPrintHandler = () => {
    if (props.nfce) {
      props.onPrint(props.nfce);
    }
  };

  const onDownloadXmlHandler = () => {
    if (props.nfce) {
      props.onDownloadXml(props.nfce);
    }
  };

  const onFetchStatusHandler = () => {
    if (props.nfce) {
      props.onFetchStatus(props.nfce);
    }
  };

  const onDownloadDanfe = () => {
    if (props.nfce) {
      props.onDownloadDanfe(props.nfce);
    }
  };

  const onShareDanfe = () => {
    if (props.nfce) {
      props.onShareDanfe(props.nfce);
    }
  };

  return (
    <>
      <Modal show={props.show} centered>
        <Modal.Body>
          <Row>
            <Col xs={6}>Número NFCe: {props.nfce?.numeroNF}</Col>
            <Col xs={6}>Serie: {props.nfce?.serie}</Col>
          </Row>
          <Row>
            <Col xs={12}>
              Status Envio: {props.nfce?.autorizacao?.codigoStatusEnvio}-
              {props.nfce?.autorizacao?.descricaoStatusEnvio}
            </Col>
          </Row>
          <Row>
            <Col xs={12}>
              Status Resposta: {props.nfce?.autorizacao?.codigoStatusResposta}-
              {props.nfce?.autorizacao?.descricaoMotivoResposta}
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          {finalizada && (
            <>
              <DropdownButton
                variant="outline-primary"
                title="DANFE"
                id="dropdown-imprimir"
                className="messagebox-btn-cancel"
              >
                <Dropdown.Item onClick={onPrintHandler}>
                  Imprimir agora
                </Dropdown.Item>

                <Dropdown.Item onClick={onShareDanfe}>
                  Compartilhar
                </Dropdown.Item>
                <Dropdown.Item onClick={onDownloadDanfe}>Baixar</Dropdown.Item>
              </DropdownButton>
              <Button
                variant="outline-primary"
                className="messagebox-btn-cancel"
                onClick={onDownloadXmlHandler}
              >
                Baixar XML
              </Button>
            </>
          )}
          {!finalizada && (
            <>
              <Button
                variant="outline-danger"
                className="messagebox-btn-cancel"
                onClick={onDeleteHandler}
              >
                Excluir
              </Button>

              <Button
                variant="outline-primary"
                className="messagebox-btn-cancel"
                onClick={onFetchStatusHandler}
              >
                Consultar Situação
              </Button>
            </>
          )}

          <Button
            variant="outline-primary"
            className="messagebox-btn-cancel"
            onClick={onVisualizarHandler}
          >
            Visualizar
          </Button>

          <Button
            variant="outline-primary"
            className="messagebox-btn-cancel"
            onClick={onReturnHandler}
          >
            Sair
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default NFCeModalPropriedadesView;
